import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from 'sleep-promise';

function Form() {
    const profileFilter = chooseProfileFilter();

    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/bankinghistories/';
    const paths = {
        endpointSave: config.endpoints.backend + 'bankinghistories/save',
        endpointGetById: config.endpoints.backend + 'bankinghistories/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllBankAccounts: config.endpoints.backend + 'bankaccounts/getall',
        endpointVerifyBankAccountFromFile: config.endpoints.backend + 'bankinghistories/verifyBankAccountFromFile',
        urlGoBack: path + 'competencies',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Importar Extrato",
        labelTitleEdit: "",
        labelTitleView: ""
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_bank_account_id',
                    type: 'select',
                    label: 'Conta Bancária',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBankAccounts,
                        label: 'accountid',
                        value: 'id',
                        params: {
                            filter: {
                                pdc_project_id: values.pdc_project_id || 'not-list'
                            }
                        }
                    },
                    validations: {
                        required: true,
                        verifyBankAccountFromFile: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'file',
                    type: 'file',
                    label: 'Arquivo OFX',
                    extensionAccept: '.ofx',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                verifyBankAccountFromFile: async (value, options, key, attributes) => {
                    if (attributes.file && attributes.pdc_bank_account_id) {
                        const verify = await Fetch.post(paths.endpointVerifyBankAccountFromFile, { ...attributes })
                        if (!verify.sucess) {
                            if (verify.fileError) {
                                return '^ Verifique a estrutura do arquivo e tente novamente.'
                            } else {
                                return '^ Conta bancária não está correta de acordo com o arquivo.'
                            }
                        }
                    } else {
                        return '';
                    }
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
